import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { Promotion } from '@interfaces';
import { useStore } from '@store';

import SectionPromotions from '@components/Sections/SectionPromotions.vue';


const __default__ = { name: 'MainSectionPromotions' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

const promotions = computed(() => {
  return store.state.promotions.items.map((promo: Promotion) => ({
    id: promo.id,
    title: promo.title,
    body: promo.body,
    url: promo.url ?? null,
    image: promo.image ?? null,
    youtubeVideoId: promo.youtubeVideoId ?? null,
    callToAction: promo.callToAction ?? null,
    textAlign: promo.textAlign ?? null,
    startDate: promo.startDate ?? null,
    endDate: promo.endDate ?? null,
  }));
});

return { __sfc: true,store, promotions, SectionPromotions }
}

})